import classNames from 'classnames'
import styles from './styles.module.scss'

const EverlaneLogo = ({ height, className = null }) => {
  return (
    <svg
      width="124"
      height={height}
      className={classNames(styles['everlane-logo'], className)}
      viewBox="0 0 600 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M378.252 70.0001H385.717L409.194 8.64306H407.595L431.072 70.0001H438.714L411.682 1.00009H405.284L378.252 70.0001ZM424.479 44.0318H392.293L389.804 50.4306H426.967L424.479 44.0318ZM600 1.00009H555.551V70.0001H600V63.0681H562.66V37.8108H596.623V31.2343H562.66V7.93209H600V1.00009ZM202.198 1.00009H157.749V70.0001H202.198V63.0681H164.858V37.8108H198.821V31.2343H164.858V7.93209H202.198V1.00009ZM321.7 63.0681V1.00009H314.591V70.0001H356.73V63.0681H321.7ZM253.934 40.2992C270.48 42.0766 282.032 35.1446 282.032 21.2629C282.032 8.46532 274.39 0.982315 257.666 0.982315H232.411V69.9824H239.52V40.9924H246.096C259.07 40.9924 262.287 46.6802 267.441 55.5674L275.616 69.9646H283.791L273.839 52.5279C268.507 43.2853 264.419 39.9081 257.115 39.5527L253.916 40.2636L253.934 40.2992ZM258.395 34.6114H239.538V7.93209H257.684C270.302 7.93209 274.941 12.5534 274.941 21.0851C274.941 29.0836 270.498 34.5936 258.395 34.5936V34.6114ZM128.744 1.00009H121.102L97.6244 62.3572H99.2239L75.7642 1.00009H67.9443L94.9763 70.0001H101.73L128.744 1.00009ZM518.015 1.00009H511.262V60.2242H512.861L473.566 1.00009H466.635V70.0001H473.389V10.9537H471.967L511.084 70.0001H518.015V1.00009ZM44.4491 1.00009H0V70.0001H44.4491V63.0681H7.109V37.8108H41.0723V31.2343H7.109V7.93209H44.4491V1.00009Z"
        fill="black"
      />
    </svg>
  )
}

export default EverlaneLogo
